<template lang="pug">
.StepIndicator
  .stepItem(
    v-for="index in totalCount"
    :key="index"
    :class="{ done: index < currentCount, current: index === currentCount }"
  )
</template>

<script>
// import soundService from '@/services/SoundService'

export default {
  name: 'km-step-indicator',
  components: {},
  props: {
    totalCount: {
      type: Number,
      default: 1
    },
    currentCount: {
      type: Number,
      default: 1
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.StepIndicator {
  display: flex;
  margin: 0 auto;
  width: 40%;
  height: 20px;
  border: 3px solid #000;
  border-radius: 5px;
  overflow: hidden;

  &::after {
    content: '';
    position: absolute;
    top: 6px;
    left: 0;
    border-bottom: 5px solid black;
    width: 100%;
    // z-index: 50;
  }
}

.stepItem {
  flex: 1;
  position: relative;
  height: 100%;
  border-right: 1px solid #000;
  background: gray;
  transition: background ease 0.5s;
  z-index: 10;

  &:last-child {
    border-right: 0;
  }

  &.done {
    background: yellow;
  }

  &.current {
    background: lightyellow;
  }
}
</style>
